import React from "react";
import { createPortal } from "react-dom";

const ICONS = "/assets/mobile/menu";

const Divider = () => <div className="bg-[#e5e7eb] h-px shrink-0 w-full" />;

const MenuIcon = ({ name, size = 20 }) => (
  <img src={`${ICONS}/${name}.svg`} alt="" width={size} height={size} className="block max-w-none shrink-0" style={{ width: size, height: size }} />
);

const MenuItem = ({ icon, label, onClick }) => (
  <button type="button" onClick={onClick} className="flex items-center justify-between px-2 py-[14px] w-full">
    <span className="flex gap-4 items-center min-w-0">
      <span className="flex items-center justify-center shrink-0 size-6"><MenuIcon name={icon} /></span>
      <span className="font-medium text-[#1f2937] text-[15px] text-left">{label}</span>
    </span>
    <MenuIcon name="chevron-right" size={16} />
  </button>
);

/* ─── logged-in side menu; the logged-out drawer stays in Navbar ───
   Portalled out of antd's Header: its stacking context would keep the panel under the
   floating chat button, and its 64px line-height would stretch every row. */
const MenuDrawerMob = ({ name, email, image, onClose, onNavigate, onLogout }) => createPortal(
  <div className="fixed inset-0 z-[10001]">
    <div className="absolute inset-0 bg-black/40" onClick={onClose} />
    <div className="absolute bg-white drop-shadow-[-8px_0px_12px_rgba(0,0,0,0.15)] flex flex-col font-['Outfit'] h-full max-w-[360px] right-0 rounded-bl-[42px] rounded-tl-[42px] top-0 w-[85vw]">
      <div className="flex flex-1 flex-col gap-6 items-start min-h-0 overflow-y-auto pt-8 px-6">
        <div className="flex gap-3 items-center justify-between shrink-0 w-full">
          <a href="/" onClick={onClose} className="shrink min-w-0">
            <img src={`${ICONS}/logo.svg`} alt="WowCarz" width={146} height={56} className="block h-14 max-w-full object-contain w-[146px]" />
          </a>
          <button type="button" onClick={onClose} aria-label="Close menu" className="flex items-center justify-center shrink-0 size-6">
            <MenuIcon name="x-circle" size={24} />
          </button>
        </div>

        <span className="block font-bold leading-normal shrink-0 text-[#6b7280] text-[12px] tracking-[2px] uppercase">Menu</span>

        <div className="flex flex-col gap-4 items-start pb-4 shrink-0 w-full">
          <button type="button" onClick={() => onNavigate("/profile")} className="flex gap-2 items-center justify-between px-2 py-[14px] w-full">
            <span className="flex flex-1 gap-4 items-center min-w-0">
              <img src={image || "/assets/dummy.jpeg"} alt="" className="border border-[#e5e7eb] object-cover rounded-full shrink-0 size-12" />
              <span className="flex flex-1 flex-col gap-[2px] items-start min-w-0">
                <span className="block font-bold leading-normal text-[#1f2937] text-[16px] text-left truncate w-full">{name}</span>
                <span className="block font-medium leading-normal text-[#6b7280] text-[13px] text-left truncate w-full">{email}</span>
              </span>
            </span>
            <MenuIcon name="chevron-right" size={16} />
          </button>

          <Divider />

          <div className="flex flex-col gap-[2px] w-full">
            <MenuItem icon="handshake" label="Partner with Us" onClick={() => { window.open("https://partner-with-us.wowcarz.in/", "_blank", "noreferrer"); onClose(); }} />
            <MenuItem icon="help-circle" label="FAQs" onClick={() => onNavigate("/faq")} />
          </div>

          <Divider />

          <div className="flex flex-col gap-[2px] w-full">
            <MenuItem icon="file-text" label="Terms & Conditions" onClick={() => onNavigate("/tandc")} />
            <MenuItem icon="file-text" label="Privacy Policy" onClick={() => onNavigate("/privacypolicy")} />
            <MenuItem icon="info" label="About us" onClick={() => { window.open("/about-us", "_blank"); onClose(); }} />
          </div>
        </div>
      </div>

      <div className="pb-8 pt-3 px-6 shrink-0">
        <button type="button" onClick={onLogout} className="bg-white border border-[#ff4242] flex gap-3 h-11 items-center px-3 rounded-[12px] w-full">
          <MenuIcon name="log-out" size={18} />
          <span className="font-semibold text-[#c40000] text-[14px]">Log out</span>
        </button>
      </div>
    </div>
  </div>,
  document.body
);

export default MenuDrawerMob;
